import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouteGuard } from '@common/services/authentication/auth-guard.service';

const routes: Routes = [
    { path: '', redirectTo: 'PST', pathMatch: 'full' },
    { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
    { path: 'PST', canLoad: [RouteGuard], loadChildren: () => import('./platform/platform.module').then(m => m.PlatformModule) },
    { path: '**', redirectTo: 'PST'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' })
//        RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy', enableTracing: true })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
